// extracted by mini-css-extract-plugin
export default {"error":"personal_error__6s7Do","actions":"personal_actions__AEaL4"};